import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import DigitalWorld from './components/DigitalWorld';
import Packages from './components/Packages';
import Works from './components/Works';
import ThreeD from './components/ThreeD';
import Process from './components/Process';
import Services from './components/Services';
import WhyUs from './components/WhyUs';
import FinalCTA from './components/FinalCTA';
import Contact from './components/Contact';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';
import BetaBot from './components/BetaBot';
import { Toaster } from './components/ui/toaster';

function Home() {
  return (
    <div className="App relative">
      <Header />
      <main>
        <Hero />
        <DigitalWorld />
        <Packages />
        <Works />
        <ThreeD />
        <Process />
        <Services />
        <WhyUs />
        <FinalCTA />
        <Contact />
      </main>
      <Footer />
      <CookieBanner />
      <BetaBot />
      <Toaster />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
